<template>
<div class="slide-size">
    <div class="page__header">
        <div class="search-question" data-step="1">Select your cooker size</div>
    </div>
    <div class="page__content">
      <div class="cooker-size-selection">
        <img src="static/cupboard-left.png" />
        <button @click="filterBySize(60)">60 cm</button>
        <button @click="filterBySize(90)">90 cm</button>
        <button @click="filterBySize(100)">100 cm</button>
        <button @click="filterBySize(110)">110 cm</button>
        <img src="static/cupboard-right.png" />
      </div>
    </div>
</div>
</template>
<script>
export default {
  methods: {
    filterBySize(size) {
      this.$ga.event('filter', 'size', size);
      this.$router.push({ name: "style", params: { size } });
    }
  },
  mounted(){
    this.$ga.screenview('size');
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/slide-1-size.vue